import { syncFloatingIconsPosition } from '../helpers/utils';
import { buildKustomerConversationUrl, CSQ_KUSTOMER_CHAT_STARTED_EVENT, CSQ_KUSTOMER_CONVERSATION_ID_VAR, CSQ_KUSTOMER_CONVERSATION_URL_VAR, KUSTOMER_CSQ_REPLAY_LINK_ATTR, } from '../constants/kustomer.constants';
import { csqTrackDynamicVariable, csqTrackPageEvent, generateCSQReplayLink } from './analytics.service';
import { toggleAccessibleIcon } from './accessibility.service';
const KUSTOMER_LOADED = 'kustomerLoaded';
function bindKustomerAccessibilityListeners() {
    const onOpen = () => toggleAccessibleIcon('hide');
    const onClose = () => toggleAccessibleIcon('show');
    window.Kustomer?.addListener?.('onOpen', onOpen);
    window.Kustomer?.addListener?.('onClose', onClose);
}
function bindKustomerContentsquareIntegration() {
    window.Kustomer?.addListener?.('onConversationCreate', handleKustomerConversationCreate);
}
export async function handleKustomerConversationCreate(response, error) {
    if (error) {
        console.error('Kustomer onConversationCreate error', error);
        return;
    }
    if (!response?.conversationId) {
        return;
    }
    csqTrackPageEvent(CSQ_KUSTOMER_CHAT_STARTED_EVENT);
    csqTrackDynamicVariable(CSQ_KUSTOMER_CONVERSATION_ID_VAR, response.conversationId);
    const orgSlug = window.UNTUCKitConfig.kustomerLiveChat?.orgSlug;
    if (orgSlug) {
        csqTrackDynamicVariable(CSQ_KUSTOMER_CONVERSATION_URL_VAR, buildKustomerConversationUrl(orgSlug, response.conversationId));
    }
    try {
        const replayLink = await generateCSQReplayLink(true);
        if (!replayLink) {
            console.warn('Contentsquare replay link unavailable for Kustomer conversation');
            return;
        }
        window.Kustomer?.describeConversation?.({
            conversationId: response.conversationId,
            customAttributes: {
                [KUSTOMER_CSQ_REPLAY_LINK_ATTR]: replayLink,
            },
        }, (_callbackResponse, describeError) => {
            if (describeError) {
                console.error('Failed to attach Contentsquare replay link to Kustomer conversation', describeError);
            }
        });
    }
    catch (err) {
        console.error('Failed to integrate Kustomer with Contentsquare', err);
    }
}
function loadKustomerWidget(scriptUrl, apiKey) {
    const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);
    if (existingScript?.dataset.kustomerStarted === 'true') {
        return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
        let scriptEl = existingScript;
        const onKustomerLoaded = () => {
            window.removeEventListener(KUSTOMER_LOADED, onKustomerLoaded);
            scriptEl?.setAttribute('data-kustomer-started', 'true');
            resolve();
        };
        window.addEventListener(KUSTOMER_LOADED, onKustomerLoaded);
        if (existingScript) {
            if (window.Kustomer) {
                onKustomerLoaded();
            }
            return;
        }
        scriptEl = document.createElement('script');
        scriptEl.src = scriptUrl;
        scriptEl.setAttribute('data-kustomer-api-key', apiKey);
        scriptEl.addEventListener('error', () => {
            window.removeEventListener(KUSTOMER_LOADED, onKustomerLoaded);
            reject(new Error('Failed to load Kustomer widget script'));
        });
        // Kustomer requires the embed script in body, not head — see load-chat-asynchronously docs.
        document.body.appendChild(scriptEl);
    });
}
export async function initKustomerLiveChat() {
    const settings = window.UNTUCKitConfig.kustomerLiveChat;
    if (!settings?.toggle || document.body.classList.contains('loggedin-associate')) {
        return;
    }
    try {
        await loadKustomerWidget(settings.scriptUrl, settings.apiKey);
    }
    catch (err) {
        console.error('Failed to load Kustomer live chat script', err);
        return;
    }
    if (!window.Kustomer) {
        console.error('Kustomer not found on window object');
        return;
    }
    console.log('starting Kustomer live chat...');
    window.Kustomer.start({
        brandId: settings.brandId,
        chatIconSize: settings.chatIconSize,
        chatIconPosition: { alignment: 'right', verticalPadding: 10, horizontalPadding: 10 },
        preferredView: settings.preferredView,
    }, () => {
        syncFloatingIconsPosition();
        bindKustomerAccessibilityListeners();
        bindKustomerContentsquareIntegration();
        window.Kustomer?.isChatAvailable?.((result) => {
            console.log('Kustomer chat availability:', result?.availability);
            if (result?.availability === 'hidden' || result?.availability === 'disabled') {
                console.warn('Kustomer chat icon is not shown — check Chat Management settings (business hours, URL overrides, or brand availability).');
            }
        });
    });
}
